import axios from 'axios'
import { host } from '../../helper/config'
import { ITEM_PER_PAGE } from '../../helper/helper'
import { getPublicIp } from '../../helper/publicIp'

const PLUGINS_NAME = 'admin-charge'
const CHARGE_USER_PLUGIN_NAME = 'admin-charge-user'

export { getPublicIp }

// GET LIST CHARGE
export const getListCharge = async (token, query, page, endPointId) => {
    const response = await axios.post(
        `${host}/${PLUGINS_NAME}/get-list-charge`,
        {
            ...query,
            page: page,
            itemPerPage: ITEM_PER_PAGE,
            endPointId: endPointId
        },
        {
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Authorization': token
            },
        }
    )

    if (response && response.status === 200) {
        return response.data || {}
    }
    return {}
}

export const getSummaryCharge = async (token, query, endPointId) => {
    const response = await axios.post(`${host}/${PLUGINS_NAME}/get-summary-charge`, {
        ...query,
        endPointId: endPointId
    }, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Authorization': token
        },
    })

    if (response && response.status === 200) {
        return response.data || {}
    }
    return null
}

export const getCsvCharge = async (token, query, page, totalPage) => {
    const response = await axios.post(`${host}/${PLUGINS_NAME}/get-csv-charge`, {
        ...query,
        page: page,
        itemPerPage: ITEM_PER_PAGE,
        totalPage: totalPage
    }, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Authorization': token
        },
    })
    
    if (response && response.status === 200) {
        return response.data || {}
    }
    return null
}

export const getAllChargeUser = async (token) => {
    const response = await axios.post(`${host}/${CHARGE_USER_PLUGIN_NAME}/get-all`, {}, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Authorization': token
        },
    })

    if (response && response.status === 200) {
        return response.data || {}
    }
    return {}
}

// ADD CHARGE
export const addCharge = async (token, chargeValue, chargeMethod, accountId, phone, referenceNumber, chargedBy, password) => {
    try {
        const ip = await getPublicIp()

        const headers = {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Authorization': token
        }
        if (ip) {
            headers['X-Client-IP'] = ip
        }

        const response = await axios.post(
            `${host}/${PLUGINS_NAME}/add-charge`,
            {
                chargeValue: chargeValue,
                chargeMethod: chargeMethod,
                accountId: accountId,
                userId: phone,
                referenceNumber: referenceNumber.trim() === '' ? new Date().getTime().toString() : referenceNumber,
                chargedBy: chargedBy,
                password: password
            },
            { headers }
        )

        if (response && response.status === 200) {
            return { success: true, data: response.data }
        }
        return { success: false, message: 'Có lỗi xảy ra' }
    } catch (err) {
        const message = err.response?.data?.message || 'Có lỗi xảy ra'
        return { success: false, message }
    }
}

export const getListIssueCharge = async (token, query, page) => {
    const response = await axios.post(
        `${host}/${PLUGINS_NAME}/get-list-charge-issue`,
        {
            ...query,
            page: page,
            itemPerPage: ITEM_PER_PAGE
        },
        {
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Authorization': token
            },
        }
    )

    if (response && response.status === 200) {
        return response.data || {}
    }
    return {}
}

export const deleteIssueCharge = async (token, id) => {
    const response = await axios.post(
        `${host}/${PLUGINS_NAME}/delete-charge-issue`,
        {
            id: id
        },
        {
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Authorization': token
            },
        }
    )

    if (response && response.status === 200) {
        return response.data || {}
    }
    return {}
}
